import ApiClient from "../api-client"

const optionsPerPage = 10;
var _data = [];
var countData = 0;

const loadCurrenciesOptions = async (search, page, props) => {
    var sortBy = "name";
    var order = "asc";
    var simpleColumnFilters;
    if (search) {
        simpleColumnFilters = [{
            column: "name",
            filter: search,
            filterType: "text",
            searchOperator: "contains"
        }];
    }
    var object = {
        "quickSearch": "",
        "pageNo": page,
        "sortBy": sortBy,
        "order": order,
        "pageSize": optionsPerPage,
        "simpleColumnFilters": simpleColumnFilters
    };
    const result = await ApiClient.getCurrencyRatesPage(object);
    var data = result.data.objectList;

    if (page == 1) {
        countData = data.length;
    } else {
        countData += data.length;
    }

    _data = [];
    data.forEach(element => {
        _data.push({
            label: element.name + " (" + element.symbol + ")",
            code: element.name + " (" + element.symbol + ")",
            rate: element.rate,
            value: element.symbol,
            model: element
        });
    });

    const hasMore = Math.ceil(countData / optionsPerPage) >= page;

    return {
        options: _data,
        hasMore
    };
};

export default loadCurrenciesOptions;
